import React, { useState } from 'react';
import {useNavigate}              from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';

const envLabel = process.env.REACT_APP_ENV_LABEL || ''

/********************************/
/*    症状カード表示用レコード    */
/* 関連画面：
  個人ホーム画面:PersonalHome.js */
/********************************/

/**
 * 症状カード（診療情報）1件の表示用データ。
 * PersonalHome 側で組み立てた一覧要素が入る。
 * @typedef {Object} MedicalRecordItem
 * @property {string} MedicalRecordId 症状カード（診療情報）ID
 * @property {string} MemberID メンバーID
 * @property {string} [Diagnosis] 診断結果（旧互換）
 * @property {Date|null} [CreateTime] 登録日（表示用）
 * @property {string} [Title] 病名（旧表示・互換用）
 * @property {string} [Reason_for_Consultation] 受診理由（設計優先）
 * @property {string} [HospitalName] 受診医療機関名
 * @property {string} [MedicalSpecialty] 診療科
 * @property {string} [memberName] 一覧表示用の表示名
 * @property {string} [member_url] 一覧表示用のアイコン画像URL
 * @property {string} [uid] ログインユーザーuid
 */

/**
 * @typedef {Object} MedicalRecordProps
 * @property {MedicalRecordItem} record 症状カード表示用レコード
 * @property {string} FamilyID 家族ID
 */

/**
 * 症状カード一覧の1件を表示し、クリックで `SymptomCard` へ遷移する。
 * @param {MedicalRecordProps} props
 */
export default function MedicalRecord(props) {
  /**
   * MedicalRecord
   * 症状カード一覧の1件を表示し、クリックで`SymptomCard`へ遷移するカード。
   * @param {object} props プロパティ
   * @param {object} props.record 症状カードレコード（`MedicalRecordId`, `MemberID`, `Diagnosis` 等を含む）
   * @param {string} props.FamilyID 家族ID
   */
  /** @type {import('react-router-dom').NavigateFunction} 画面遷移関数 */
  const navigate = useNavigate()
  // const [ medicalrecordid, setmedicalrecordid ] = useState(props.record.MedicalRecordId)
  // const [ record,          setRecord          ] = useState(props.record)
  // const [ memberName,      setMemberName      ] = useState(props.record.memberName)
  // const [ member_url,      setMember_url      ] = useState(props.record.member_url)
  // const [ memberID,        setMemberID        ] = useState(props.record.MemberID)
  // const [ familyID,        setFamilyID        ] = useState(props.FamilyID)
  // const [ uid,             setUid             ] = useState(props.record.uid)
  /** @type {string} 症状カードID（propsからの初期値を固定して使用） */
  const [ medicalrecordid, ] = useState(props.record.MedicalRecordId)
  /** @type {MedicalRecordItem} 表示対象レコード（propsからの初期値を固定して使用） */
  const [ record,          ] = useState(props.record)
  /** @type {string} 表示名（遷移先への引き継ぎにも利用） */
  const [ memberName,      ] = useState(props.record.memberName)
  /** @type {string} アイコン画像URL（遷移先への引き継ぎにも利用） */
  const [ member_url,      ] = useState(props.record.member_url)
  /** @type {string} メンバーID（遷移先への引き継ぎにも利用） */
  const [ memberID,        ] = useState(props.record.MemberID)
  /** @type {string} 家族ID（遷移先への引き継ぎにも利用） */
  const [ familyID,        ] = useState(props.FamilyID)
  /** @type {string} ログインユーザーuid（遷移先への引き継ぎにも利用） */
  const [ uid,             ] = useState(props.record.uid)

  // console.log(`MedicalRecord props[${JSON.stringify(props,null,'\t')}]`);
  // console.log(`MedicalRecord props.record[${JSON.stringify(props.record,null,'\t')}]`);
  // console.log(`MedicalRecord MedicalRecordId[${props.record.MedicalRecordId}]`);
  // console.log(`MedicalRecord memberName[${props.record.memberName}]`);
  // console.log(`MedicalRecord member_url[${props.record.member_url}]`);
  // console.log(`MedicalRecord uid[${props.record.uid}]`);
  // console.log(`MedicalRecord FamilyID[${props.FamilyID}]`);
  // console.log(`MedicalRecord MemberID[${props.record.memberID}]`);

  /**
   * 症状カード詳細へ遷移するハンドラー。
   * `navigate('/SymptomCard/:MedicalRecordId', { state: ... })` を実行。
    * @returns {void}
   */
  const handleSymptomCard = () => {
    console.log('症状カードUID:'+uid)
    console.log('MedicalRecordId:'+record.MedicalRecordId)
    console.log('FamilyID:' + familyID)
    document.title = `個人ホーム - ふぁみかるくん${envLabel}`
    window.history.pushState(null, `診療情報 - ふぁみかるくん`, "/SymptomCard/" + medicalrecordid)
    document.title = `診療情報 - ふぁみかるくん${envLabel}`
    // this.props.history.push({
    //   // pathname: '/followup',
    //   pathname: '/SymptomCard/'+record.MedicalRecordId,
    //   state: {
    //     uid:             uid,                    //ログインユーザーuid
    //     //MedicalRecordId: this.state.record.MedicalRecordId, //診療情報のレコードID
    //     record:          record,                 //診療情報のレコード本体
    //     FamilyID:        FamilyID,               //診療情報登録対象の家族ID
    //     MemberID:        record.MemberID,        //診療情報登録対象のメンバーID
    //     DisplayName:     memberName,             //診療情報登録対象の表示名
    //     member_url:      member_url,             //診療情報登録対象のアイコン画像パス
    //     Diagnosis:       record.Diagnosis,       //診療情報の診断結果
    //     HospitalName:    record.HospitalName,    //診療情報の医療機関名
    //   }
    // })
    navigate('/SymptomCard/' + medicalrecordid, 
      {
        state: {
          uid: uid, 
          record: record, 
          member_url: member_url, 
          FamilyID: familyID, 
          MemberID: memberID, 
          DisplayName: memberName, 
          Diagnosis: record.Diagnosis, 
          HospitalName: record.HospitalName
        }
      }
    )
    console.log(`username: ${memberName}`);
  }

  /**
   * 日付を `YYYY/MM/DD（曜）` 形式に整形する。
   * @param {Date|null|undefined} date 表示対象日付
   * @returns {string}
   */
  const formatDateWithWeekday = (date) => {
    if (!date || Object.prototype.toString.call(date) !== '[object Date]' || Number.isNaN(date.getTime())) return ''
    const y = date.getFullYear()
    const m = (date.getMonth() + 1).toString()
    const d = date.getDate().toString()
    const w = ["日", "月", "火", "水", "木", "金", "土"][date.getDay()]
    return `${y}年${m}月${d}日（${w}）`
  }

  /**
   * カード内の「受診理由」表示文言を返す（設計優先）。
   * @returns {string}
   */
  const getReasonText = () => {
    return record.Reason_for_Consultation || record.Title || ''
  }

  /**
   * カード内の「受診医療機関＋診療科」表示文言を返す。
   * 未登録時は表示しない。
   * @returns {string}
   */
  const getHospitalSpecialtyText = () => {
    const hospital = record.HospitalName || ''
    const specialty = record.MedicalSpecialty || ''
    if (hospital === '' && specialty === '') return ''
    return `${hospital}${(hospital !== '' && specialty !== '') ? '　' : ''}${specialty}`
  }

  return(
    <>
      <Card>
        <CardActionArea onClick={()=>{handleSymptomCard()}}>
          <CardContent style={{ padding: '4px 8px', margin: '0px', border: '1px solid #ddd' }}>
            <div className="text-left textTitle famikarColor">
              <Typography variant="subtitle1" className="border-bottom" component="div">
                <div style={{textAlign:'left', fontSize:'1rem', margin:'2px'}}>
                  登録日　　{formatDateWithWeekday(record.CreateTime)}
                </div>
              </Typography>
              <Typography variant="body1" component="div">
                <Grid container direction="row" justifyContent="space-between" alignItems="flex-end">
                  <Grid item xs={12}> {/* 受診科目、医療機関の表示領域をカード幅いっぱいに広げるため、xs=6 ⇒ xs=12に変更。 2020/07/11 */}
                    <div style={{width:'100%', fontSize:'1rem', margin:'2px'}}>
                      <Grid container justifyContent="flex-start" alignItems="flex-start">
                        <Grid item xs={12}>
                          <div style={{textAlign:'left'}}>
                            受診理由　{getReasonText()} {/* 受診理由（設計優先） */}
                          </div>
                        </Grid>
                        <Grid item xs={12}>
                          <div style={{textAlign:'left'}}>
                            医療機関　{getHospitalSpecialtyText()}
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </Grid>
              </Typography>
            </div>
          </CardContent>
        </CardActionArea>
      </Card>
    </>
  )
}
